import moment from "moment";
import { FAILURE, GET, POST, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function obtenerListaGrupoGeocerca(obj, combo = false, tag) {
    try {
        let data = [];
        const { code, body } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/grupo-geocerca/obtener-lista-grupo-geocerca",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            // data.error = false;
            data = body;
            if (combo === false) {
                for (let i = 0; i < data.length; i++) {
                    data[i].fechaProceso = moment(data[i].fechaProceso).format("YYYY/MM/DD HH:mm");
                    data[i].habilitadoLabel = data[i].habilitado === 1 ? tag("column_habilitado") : tag("column_deshabilitado");
                }
            }
            if (combo === true) {
                data = data.map((item) => {
                    return {
                        value: item.id,
                        label: item.codigo + " - " + item.descripcion,
                        idGrupoGeocerca: item.idGrupo,
                        idConceptoGeocerca: item.idConceptoGeocerca,
                    };
                });
            }
        }
        return data;
    } catch (err) {
        console.log("obtenerListaGrupoGeocerca err");
        console.log(err);
        return [];
    }
}

export async function crearGrupoGeocerca(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/grupo-geocerca/crear-grupo-geocerca",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("crearGrupoGeocerca err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function actualizarGrupoGeocerca(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/grupo-geocerca/actualizar-grupo-geocerca",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("actualizarGrupoGeocerca err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function deshabilitarGrupoGeocerca(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/grupo-geocerca/deshabilitar-grupo-geocerca",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("deshabilitarGrupoGeocerca err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function habilitarGrupoGeocerca(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/grupo-geocerca/habilitar-grupo-geocerca",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("habilitarGrupoGeocerca err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function obtenerGrupoGeocerca() {
    try {
        let data = { error: true, body: [] };
        const { code, body, message } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/grupo-geocerca/obtener-grupo-geocerca",
            {
                headers: getHeaders(),
                method: GET,
                // body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        if (code === SUCCESS) {
            data.error = false;
            data.body = body;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("obtenerGrupoGeocerca err");
        console.log(err);
        return { error: true, message: err, body: [] };
    }
}

export async function obtenerGeocercas() {
    try {
        let data = { error: true, body: [] };
        const { code, body, message } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/grupo-geocerca/obtener-geocercas",
            {
                headers: getHeaders(),
                method: GET,
                // body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        if (code === SUCCESS) {
            data.error = false;
            data.body = body;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("obtenerGeocercas err");
        console.log(err);
        return { error: true, message: err, body: [] };
    }
}

export async function obtenerGeocercasPorIdGrupoGeocerca(obj) {
    try {
        let data = { error: true, body: [] };
        const { code, body, message } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/grupo-geocerca/obtener-geocercas-por-id-grupo-geocerca",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        if (code === SUCCESS) {
            data.error = false;
            data.body = body;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("obtenerGeocercasPorIdGrupoGeocerca err");
        console.log(err);
        return { error: true, message: err, body: [] };
    }
}

export async function obtenerListaGrupoGeocercaExternal(obj, combo = false, tag) {
    try {
        let data = [];
        const { code, body } = await fetch(
            "https://gestiondeflota.boltrack.net/apiultimamillav3/api/grupo-geocerca/obtener-lista-grupo-geocerca-external",
            {
                headers: getHeaders(false),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            // data.error = false;
            data = body;
            if (combo === false) {
                for (let i = 0; i < data.length; i++) {
                    data[i].fechaProceso = moment(data[i].fechaProceso).format("YYYY/MM/DD HH:mm");
                    data[i].habilitadoLabel = data[i].habilitado === 1 ? tag("column_habilitado") : tag("column_deshabilitado");
                }
            }
            if (combo === true) {
                data = data.map((item) => {
                    return {
                        value: item.id,
                        label: item.codigo + " - " + item.descripcion,
                        idGrupoGeocerca: item.idGrupo,
                        idConceptoGeocerca: item.idConceptoGeocerca,
                    };
                });
            }
        }
        return data;
    } catch (err) {
        console.log("obtenerListaGrupoGeocercaExternal err");
        console.log(err);
        return [];
    }
}